module.exports = __webpack_public_path__ + "img/api.1f18e252.png";